import { sortTranslationsBasedOnKey } from './sort-translation-on-keys';
import { TranslationKeyLanguages, TranslationsList, TranslationType } from '../../model';

export const transformTranslationsToArray = (translationsList: TranslationsList): Array<TranslationKeyLanguages> => {
  let translationsArray: Array<TranslationKeyLanguages> = [];
  for (const key in translationsList) {
    if (translationsList.hasOwnProperty(key)) {
      const localObj: TranslationKeyLanguages = { key: '', languages: {} };
      localObj.key = key;
      localObj.languages = translationsList[key] as TranslationType;
      translationsArray.push(localObj);
    }
  }
  translationsArray = sortTranslationsBasedOnKey(translationsArray);
  return translationsArray;
};
